const remoteNeuronHost = import.meta.env.VITE_NEURON_HOST as string;

let neuronHost = '';

const getNeuronHost = async () => {
  if (neuronHost) {
    return neuronHost;
  }
  const { href, pathname } = window.location;
  if (/^https?:\/\//.test(href)) {
    neuronHost = remoteNeuronHost;
    return remoteNeuronHost;
  }
  // 离线包本地href应该长这样 "file:///Users/xxx/xxx/xxxxx/xxx/fett/fett-1669633629495/index.html#/login
  // href本身可能存在?isKicked = xxx 一类的search query，需要忽略
  // 因此直接使用 pathname
  const localNeuronPathname = pathname.replace(/\/index.html$/, '/neuron/dist/index.html');
  const localNeuronHost = `${localNeuronPathname}`;
  const tryLoad = await fetch(localNeuronHost)
    .then(() => true)
    .catch(() => false);
  neuronHost = tryLoad ? localNeuronHost : remoteNeuronHost;
  return neuronHost;
};

export default getNeuronHost;
